import React from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  const affiliateLink = "https://deriv.partners/rx?sidc=8DEDCB5B-91A6-48CE-B0F7-CDC501385737&utm_campaign=dynamicworks&utm_medium=affiliate&utm_source=CU52815";

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setIsMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-200">
      <nav className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <div className="flex flex-col">
              <span className="text-xs text-gray-600 font-medium">Powered by</span>
              <span className="text-2xl font-bold text-[#ff444f]">Deriv</span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('features')} 
              className="text-gray-700 hover:text-[#ff444f] transition-colors font-medium"
            >
              Features
            </button>
            <button 
              onClick={() => scrollToSection('instruments')} 
              className="text-gray-700 hover:text-[#ff444f] transition-colors font-medium"
            >
              Markets
            </button>
            <button 
              onClick={() => scrollToSection('platforms')} 
              className="text-gray-700 hover:text-[#ff444f] transition-colors font-medium"
            >
              Platforms
            </button>
            <button 
              onClick={() => scrollToSection('faq')} 
              className="text-gray-700 hover:text-[#ff444f] transition-colors font-medium"
            >
              FAQ
            </button>
            <a 
              href={affiliateLink}
              target="_blank"
              rel="noopener noreferrer sponsored nofollow"
            >
              <Button className="bg-[#ff444f] hover:bg-[#e63946] text-white">
                Start Trading
              </Button>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMenuOpen ? (
              <X className="w-6 h-6 text-gray-700" />
            ) : (
              <Menu className="w-6 h-6 text-gray-700" />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden py-4 space-y-4 border-t border-gray-200">
            <button 
              onClick={() => scrollToSection('features')} 
              className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-[#ff444f] transition-colors font-medium"
            >
              Features
            </button>
            <button 
              onClick={() => scrollToSection('instruments')} 
              className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-[#ff444f] transition-colors font-medium"
            >
              Markets
            </button>
            <button 
              onClick={() => scrollToSection('platforms')} 
              className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-[#ff444f] transition-colors font-medium"
            >
              Platforms
            </button>
            <button 
              onClick={() => scrollToSection('faq')} 
              className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-[#ff444f] transition-colors font-medium"
            >
              FAQ
            </button>
            <div className="px-4">
              <a 
                href={affiliateLink}
                target="_blank"
                rel="noopener noreferrer sponsored nofollow"
                className="block"
              >
                <Button className="w-full bg-[#ff444f] hover:bg-[#e63946] text-white">
                  Start Trading
                </Button>
              </a>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}
